export async function asieApi(path,method='GET',body,raw=false){
 const r=await fetch(`${process.env.REACT_APP_BACKEND_URL ?? ''}/api/prospection-asie${path}`,{
  method,...(body===undefined?{}:{headers:{'Content-Type':raw?'text/csv; charset=utf-8':'application/json'},body:raw?body:JSON.stringify(body)})
 });
 const data=await r.json().catch(()=>({}));
 if(!r.ok)throw new Error(typeof data.detail==='string'?data.detail:`Erreur ${r.status}`);
 return data;
}
